// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__SxoDa","signatureButtonsRight":"ModalSign_signatureButtonsRight__2IcMn"};